import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgNotification = forwardRef(
  (props: Props, svgRef: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 24 24"
      ref={svgRef}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.643 3.381A.93.93 0 0012 3.125a.93.93 0 00-.643.256.858.858 0 00-.267.619l-.092 1.425a.75.75 0 00.001.037l.002.035c-1.274.206-2.338.84-3.172 1.788a5.13 5.13 0 00-1.292 3.39c0 2.706-.569 3.773-1.455 5.434l-.031.06a.42.42 0 00.016.424.466.466 0 00.386.207h13.095c.339 0 .557-.343.402-.632l-.03-.06c-.887-1.66-1.457-2.727-1.457-5.433a5.13 5.13 0 00-1.291-3.39c-.834-.947-1.898-1.58-3.171-1.787l.002-.027v-.018L12.91 4a.858.858 0 00-.267-.619zm.548 15.992a1.8 1.8 0 00.528-1.273h-3.6a1.8 1.8 0 003.072 1.273z"
        clipRule="evenodd"
      />
    </svg>
  )
);
SvgNotification.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgNotification;
